export default {
  en: {
    updating: 'Publishing {entity} integration',
    updated: '{entity} integration was published',
    widget: {
      title: 'Integration of Widget',
      description: 'Integrate Videsk on your web with a widget.',
      segmentsTitle: 'Services',
      segmentsSubtitle: 'Select a service you want to contact.',
      tabs: {
        colors: 'Colors and Texts',
        forms: 'Forms',
        integration: 'Integration',
      },
      integration: {
        title: 'The final step!',
        unavailable: 'Unavailable',
        soon: 'Soon',
        description: 'To integrate Videsk into your website you can copy and paste this line inside the body tag:',
        alternative: 'Or you can install with the follow plugins/modules :',
        propagate: 'The changes you make will be automatically propagated on your website.',
        sdk: 'Or you can use our Phone SDK, with your integration token.',
        devDocs: 'Developer documentation',
        plugins: {
          wordpress: 'Integrate Videsk in your WordPress website.',
          magento: 'Integrate Videsk in your Magento e-commerce.',
          prestashop: 'Integrate Videsk in your Prestashop e-commerce.',
          shopify: 'Integrate Videsk in your Shopify e-commerce.',
        },
        ssl: {
          invalid: 'The URL is not valid, please check and try again.',
          valid: 'The website is compatible with Videsk widget.',
          description: 'First need check if you website is compatible with Videsk. Need SSL in your website.',
          placeholder: 'Enter your website',
          words: {
            valid: 'Valid (Compatible)',
            expired: 'SSL Ok',
            expireon: 'Expire On',
            days: 'day | days',
            remaining: 'Remaining Days',
          },
          button: 'Check compatibility',
        },
      },
      colors: {
        select: 'Select a color',
        text: 'Text Color',
        gradient: 'Header Gradient',
        buttons: 'Background buttons',
        alert: 'Try use background colors that have a good contrast with text for inclusive design.',
        logo: {
          label: 'Logo URL:',
          tooltip: 'Logo size (Default: 31px)',
          placeholder: 'Enter de URL or logo',
        },
      },
      texts: {
        alert: 'It is advisable to fill in the fields to guide your clients and deliver more personalized attention.',
        head: {
          title: 'Title text',
          subtitle: 'Subtitle text',
          segments_title: 'Segments title',
          segments_subtitle: 'Segments subtitle',
          permissionsCameraDisclaimer: 'Alert text of camera use.',
          permissionsHeader: 'Permission subtitle',
          baseFormHeader: 'Form subtitle',
          contactFormHeader: 'Contact form subtitle',
          queueHeader: 'Queue subtitle',
          surveyHeader: 'Survey subtitle',
          surveyQuestionTitle: 'Survey question title',
          calendarViewSubtitle: 'Calendar view subtitle',
        },
        terms: {
          label: 'URL of terms and conditions',
          tooltip: 'You can add your own website for terms and conditions. Must be compatible with iframe.',
        },
      },
      form: {
        alert: 'Select a department and create/edit a form. Click on «Forms Documentation» for more information.',
        alert2: 'To request information from your customers, you must configure a form by department, otherwise information will not be requested.',
        btnDocs: 'Forms Documentation',
        example: 'A example was loaded',
        parseError: 'The JSON scheme is incorrect, correct the format. The last change was omitted',
        last: 'Automatic backup of the last change',
      },
      settings: {
        segmentFilter: {
          label: 'Settings for filter segments based on agent status.',
          hint: 'Filter which segments will shows to customers based on the agents status.',
          all: 'All',
          connected: 'Only connected',
          available: 'Only available',
        },
        defaultChannel: {
          label: 'Settings for default channel',
          hint: 'Select if you want video + audio or only audio as default setting.',
          video: 'Video + Audio',
          audio: 'Only audio',
        },
        disableAudioOnly: {
          label: 'Require camera (disable audio-only)',
          hint: 'Hide the "only microphone" option and require the camera to start the attention. Customers without a camera will not be able to connect.',
        },
      },
    },
  },
  es: {
    updating: 'Publicando Integración {entity}',
    updated: 'Integración {entity} Publicada',
    widget: {
      title: 'Integración de Widget',
      description: 'Integre Videsk en su sitio web con widget.',
      segmentsTitle: 'Servicios',
      segmentsSubtitle: 'Seleccione el servicio que desea contactar.',
      tabs: {
        colors: 'Colores y Textos',
        forms: 'Formularios',
        integration: 'Integración',
      },
      integration: {
        title: '¡Falta un solo paso!',
        unavailable: 'No disponible',
        soon: 'Pronto',
        description: 'Para integrar Videsk en tú sitio web puedes copiar y pegar esta línea dentro de la etiqueta body:',
        alternative: 'O bien puedes instalar con los siguientes plugins/módulos:',
        propagate: 'Los cambios que realices se propagarán automáticamente en tú sitio web.',
        sdk: 'O bien podrás utilizar nuestro Phone SDK, mediante tu token de integración.',
        devDocs: 'Documentación de desarrollador',
        plugins: {
          wordpress: 'Integre Videsk en su sitio WordPress.',
          magento: 'Integre Videsk en su tienda Magento.',
          prestashop: 'Integre Videsk en su tienda Prestashop.',
          shopify: 'Integre Videsk en su tienda Shopify.',
        },
        ssl: {
          invalid: 'La URL ingresada no es válida, por favor inténtalo de nuevo.',
          valid: 'El sitio web es compatible con Videsk widget.',
          description: 'Primero necesita verificar si su sitio web es compatible con Videsk. Necesita SSL en su sitio web.',
          placeholder: 'Ingresa tu sitio web',
          words: {
            valid: 'Válido (Compatible)',
            expired: 'SSL Ok',
            expireon: 'Expira el',
            days: 'día | días',
            remaining: 'Días restantes',
          },
          button: 'Verificar compatibilidad',
        },
      },
      colors: {
        select: 'Seleccione un color',
        text: 'Color texto',
        gradient: 'Gradiente cabecera',
        buttons: 'Fondo botones',
        alert: 'Intente utilizar colores de fondo que tengan un buen contraste con el texto para un diseño inclusivo.',
        logo: {
          label: 'URL logo:',
          tooltip: 'Tamaño Logo (Por defecto: 31px)',
          placeholder: 'Ingrese URL del logo',
        },
      },
      texts: {
        alert: 'Es recomendable completar los campos para guiar a sus clientes y brindarles una atención más personalizada.',
        head: {
          title: 'Texto del título',
          subtitle: 'Texto del subtítulo',
          segments_title: 'Título de segmentos',
          segments_subtitle: 'Subtítulo de segmentos',
          permissionsCameraDisclaimer: 'Texto de advertencia sobre uso de cámara',
          permissionsHeader: 'Subtitulo de permisos',
          baseFormHeader: 'Subtítulo de formulario',
          contactFormHeader: 'Subtítulo de formulario de contacto',
          queueHeader: 'Subtítulo de fila',
          surveyHeader: 'Subtítulo de encuesta',
          surveyQuestionTitle: 'Pregunta de encuesta',
          calendarViewSubtitle: 'Subtítulo vista de calendario',
        },
        terms: {
          label: 'URL de términos y condiciones',
          tooltip: 'Puede agregar su propio sitio web para los términos y condiciones. Debe ser compatible con iframe.',
        },
      },
      form: {
        alert: 'Seleccione un departamento y cree/edite un formulario. Haga clic en «Documentación de Formularios» para más información.',
        alert2: 'Para solicitar información a sus clientes deberá configurar un formulario por departamento, en caso contrario no se solicitará información.',
        btnDocs: 'Documentación de Formularios',
        example: 'Se ha cargado una plantilla',
        parseError: 'El esquema JSON es incorrecto, corrija el formato. Se ha omitido el último cambio',
        last: 'Último cambio respaldado localmente',
      },
      settings: {
        segmentFilter: {
          label: 'Filtrado de segmentos por estado de conexión',
          hint: 'Filtre los segmentos por estado de conexión de sus ejecutivos.',
          all: 'Todos',
          connected: 'Solo conectados',
          available: 'Solo disponibles',
        },
        defaultChannel: {
          label: 'Configuración de medios por defecto',
          hint: 'Selecciona entre video + audio, o solo audio para la configuración por defecto.',
          video: 'Video + audio',
          audio: 'Solo audio',
        },
        disableAudioOnly: {
          label: 'Exigir cámara (deshabilitar solo audio)',
          hint: 'Oculta la opción «solo micrófono» y exige cámara para iniciar la atención. Los clientes sin cámara no podrán conectarse.',
        },
      },
    },
  },
  fr: {
    updating: 'Publication de l\'intégration {entity}',
    updated: 'L\'intégration {entity} a été publiée',
    widget: {
      title: 'Intégration du Widget',
      description: 'Intégrez Videsk sur votre site web avec un widget.',
      segmentsTitle: 'Services',
      segmentsSubtitle: 'Sélectionnez un service avec lequel vous souhaitez entrer en contact.',
      tabs: {
        colors: 'Couleurs et Textes',
        forms: 'Formulaires',
        integration: 'Intégration',
      },
      integration: {
        title: 'L\'étape finale !',
        unavailable: 'Indisponible',
        soon: 'Bientôt',
        description: 'Pour intégrer Videsk sur votre site web, vous pouvez copier et coller cette ligne dans la balise body :',
        alternative: 'Ou vous pouvez installer avec les plugins/modules suivants :',
        propagate: 'Les modifications que vous apportez seront automatiquement propagées sur votre site web.',
        sdk: 'Ou vous pouvez utiliser notre SDK Phone, avec votre jeton d\'intégration.',
        devDocs: 'Documentation pour développeurs',
        plugins: {
          wordpress: 'Intégrez Videsk dans votre site WordPress.',
          magento: 'Intégrez Videsk dans votre e-commerce Magento.',
          prestashop: 'Intégrez Videsk dans votre e-commerce Prestashop.',
          shopify: 'Intégrez Videsk dans votre e-commerce Shopify.',
        },
        ssl: {
          invalid: 'L\'URL n\'est pas valide, veuillez vérifier et réessayer.',
          valid: 'Le site web est compatible avec le widget Videsk.',
          description: 'Vérifiez d\'abord si votre site est compatible avec Videsk. Un SSL est nécessaire pour votre site web.',
          placeholder: 'Entrez votre site web',
          words: {
            valid: 'Valide (Compatible)',
            expired: 'SSL OK',
            expireon: 'Expire le',
            days: 'jour | jours',
            remaining: 'Jours restants',
          },
          button: 'Vérifier la compatibilité',
        },
      },
      colors: {
        select: 'Sélectionnez une couleur',
        text: 'Couleur du texte',
        gradient: 'Dégradé de l\'en-tête',
        buttons: 'Couleur de fond des boutons',
        alert: 'Essayez d\'utiliser des couleurs de fond ayant un bon contraste avec le texte pour un design inclusif.',
        logo: {
          label: 'URL du logo :',
          tooltip: 'Taille du logo (Par défaut : 31px)',
          placeholder: 'Entrez l\'URL ou le logo',
        },
      },
      texts: {
        alert: 'Il est conseillé de remplir les champs pour guider vos clients et offrir une attention plus personnalisée.',
        head: {
          title: 'Texte du titre',
          subtitle: 'Texte du sous-titre',
          segments_title: 'Titre des segments',
          segments_subtitle: 'Sous-titre des segments',
          permissionsCameraDisclaimer: 'Texte d\'alerte sur l\'utilisation de la caméra.',
          permissionsHeader: 'Sous-titre de la permission',
          baseFormHeader: 'Sous-titre du formulaire de base',
          contactFormHeader: 'Sous-titre du formulaire de contact',
          queueHeader: 'Sous-titre de la file d\'attente',
          surveyHeader: 'Sous-titre de l\'enquête',
          surveyQuestionTitle: 'Titre de la question de l\'enquête',
          calendarViewSubtitle: 'Sous-titre de la vue du calendrier',
        },
        terms: {
          label: 'URL des termes et conditions',
          tooltip: 'Vous pouvez ajouter votre propre site pour les termes et conditions. Doit être compatible avec iframe.',
        },
      },
      form: {
        alert: 'Sélectionnez un département et créez/modifiez un formulaire. Cliquez sur «Documentation des formulaires» pour plus d\'informations.',
        alert2: 'Pour demander des informations à vos clients, vous devez configurer un formulaire par département, sinon les informations ne seront pas demandées.',
        btnDocs: 'Documentation des formulaires',
        example: 'Un exemple a été chargé',
        parseError: 'Le schéma JSON est incorrect, corrigez le format. Le dernier changement a été omis',
        last: 'Sauvegarde automatique du dernier changement',
      },
      settings: {
        segmentFilter: {
          label: 'Paramètres pour filtrer les segments en fonction du statut des agents.',
          hint: 'Filtrez les segments qui seront affichés aux clients en fonction du statut des agents.',
          all: 'Tous',
          connected: 'Uniquement connectés',
          available: 'Uniquement disponibles',
        },
        defaultChannel: {
          label: 'Paramètres pour le canal par défaut',
          hint: 'Sélectionnez si vous souhaitez vidéo + audio ou uniquement audio comme paramètre par défaut.',
          video: 'Vidéo + Audio',
          audio: 'Uniquement audio',
        },
        disableAudioOnly: {
          label: 'Exiger la caméra (désactiver l\'audio seul)',
          hint: 'Masque l\'option « micro uniquement » et exige la caméra pour démarrer l\'attention. Les clients sans caméra ne pourront pas se connecter.',
        },
      },
    },
  }

};
